import React from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import * as appDataActions from '../../../../actions/appDataActions';
import * as trackingDataActions from '../../../../actions/trackingDataActions';
import * as dialogPopupActions from '../../../../actions/dialogPopupActions';
import * as appHelper from '../../../../helpers/appHelper';
import * as dataHelper from '../../../../helpers/dataHelper';
import * as userDataHelper from '../../../../helpers/userDataHelper';
import * as keyboardConstants from '../../../../constants/keyboardConstants';

import * as objectConstants from '../../../../constants/objectConstants';
//import {SINGLE_ANSWER_REVIEW_CONFIG} from '../../../../models/dialogModels';
import {TweenLite, Elastic, Bounce, Expo} from 'gsap';
import gsap from 'gsap-react-plugin';

class ConversationSingleAnswerOption extends React.Component {
    constructor(props, context) {
        super(props, context);
        this.state = {
            lang: this.props.lang,
            option: this.props.option,
            focusedOption: this.props.focusedOption,
            initialised: false,
            locale: appHelper.getLocalData(this.props.option),
            responseData: this.props.responseData,
            isAnimating: false,
            focusedClass:"not-focused",
        };

        this.hideOption = this.hideOption.bind(this);
        this.showOption = this.showOption.bind(this);
        this.scaleOptionHeight = this.scaleOptionHeight.bind(this);
        this.removeOption = this.removeOption.bind(this);
        this.roundCorners = this.roundCorners.bind(this);
        this.setOptionAsSelected = this.setOptionAsSelected.bind(this);
        this.onOptionHidden = this.onOptionHidden.bind(this);
        this.onOptionRevealed = this.onOptionRevealed.bind(this);
        this.getDisabledState = this.getDisabledState.bind(this);
        this.getOptionClass = this.getOptionClass.bind(this);
        this.getClickFunction = this.getClickFunction.bind(this);
        this.handleOptionVisibility = this.handleOptionVisibility.bind(this);
        this.onAttemptComplete = this.onAttemptComplete.bind(this);
        this.setAnimationStart = this.setAnimationStart.bind(this);
        this.setAnimationEnd = this.setAnimationEnd.bind(this);
        this.getIsChecked = this.getIsChecked.bind(this);
        this.getIsDisabled = this.getIsDisabled.bind(this);
        this.setFocus = this.setFocus.bind(this);
        this.setBlur = this.setBlur.bind(this);
        this.getScreenReaderOptionClass = this.getScreenReaderOptionClass.bind(this);
    }

    componentDidMount() {
        this.handleOptionVisibility();
    }

    componentWillReceiveProps(nextProps) {
        if (this.state.responseData !== nextProps.responseData) {
            this.setState({responseData: Object.assign({}, nextProps.responseData)});
        }

        if (this.state.focusedOption !== nextProps.focusedOption) {
            this.setState({focusedOption: Object.assign({}, nextProps.focusedOption)});
        }
        if(this.state.lang !== nextProps.lang){
            this.setState({
                lang: nextProps.lang,
                locale: appHelper.getLocalData(this.state.option)
            });
        }
    }

    componentDidUpdate() {
        let optionRef = this.refs[this.state.option.option_id];
        optionRef.classList.remove("rounded");
        if (this.props.getOptionCanUpdate()) {
            this.handleOptionVisibility();
        }

    }


    setAnimationStart() {

        if (!this.state.isAnimating) {
            this.setState({isAnimating: true});
        }
    }

    setAnimationEnd() {
        this.props.setOptionCanUpdate(false);
        if (this.state.isAnimating) {
            this.setState({isAnimating: false});
        }
    }

    getOptionClass() {
        let responseData = this.state.responseData;
        let latestResponse = appHelper.getLastItemOfArray(responseData.responses);
        if (responseData.displayState !== objectConstants.OBJECT_DISPLAY_STATE_REVIEW) {
            if ((responseData.currentAttempt === responseData.responses.length) && (latestResponse.selectedOption.option_id === this.state.option.option_id)) {
                if (responseData.displayState !== objectConstants.OBJECT_DISPLAY_STATE_ANSWERED || !this.props.showFeedback) {
                    return `active`;
                } else {
                    return `selected answered ${this.state.option.result}`;
                }
            } else {
                for (let i = 0; i < this.state.responseData.responses.length; i++) {
                    let response = this.state.responseData.responses[i];
                    if (response.selectedOption.option_id === this.state.option.option_id) {
                        return `show-answer ${this.state.option.result}`;
                    }
                }
            }
        } else if (responseData.displayState === objectConstants.OBJECT_DISPLAY_STATE_REVIEW && this.props.showFeedback) {
            if ((responseData.currentAttempt === responseData.responses.length) && (latestResponse.selectedOption.option_id === this.state.option.option_id)) {
                return `review-selected answered ${this.state.option.result}`;
            } else {
                return `review ${this.state.option.result}`;
            }
        }


        return "";
    }

	getScreenReaderOptionClass() {
		let responseData = this.state.responseData;
		let latestResponse = appHelper.getLastItemOfArray(responseData.responses);
		if (responseData.displayState !== objectConstants.OBJECT_DISPLAY_STATE_REVIEW) {
			if ((responseData.currentAttempt === responseData.responses.length) && (latestResponse.selectedOption.option_id === this.state.option.option_id)) {
				if (responseData.displayState !== objectConstants.OBJECT_DISPLAY_STATE_ANSWERED || !this.props.showFeedback) {
					return "";
				} else {
					return appHelper.getOptionResultString(this.state.option.result,true);
				}
			} else {
				for (let i = 0; i < this.state.responseData.responses.length; i++) {
					let response = this.state.responseData.responses[i];
					if (response.selectedOption.option_id === this.state.option.option_id) {
                        return appHelper.getOptionResultString(this.state.option.result,true);
					}
				}
			}
		} else if (responseData.displayState === objectConstants.OBJECT_DISPLAY_STATE_REVIEW && this.props.showFeedback) {
			if ((responseData.currentAttempt === responseData.responses.length) && (latestResponse.selectedOption.option_id === this.state.option.option_id)) {
                return appHelper.getOptionResultString(this.state.option.result,false);
			} else {
                return appHelper.getOptionResultString(this.state.option.result,false);
			}
		}


		return "";
	}

    getClickFunction() {
        let responseData = this.state.responseData;
        let latestResponse = appHelper.getLastItemOfArray(responseData.responses);
        if ((responseData.currentAttempt === responseData.responses.length) && (latestResponse.selectedOption.option_id === this.state.option.option_id) && this.props.showFeedback) {
            if (responseData.displayState == objectConstants.OBJECT_DISPLAY_STATE_ANSWERED || responseData.displayState === objectConstants.OBJECT_DISPLAY_STATE_REVIEW && this.props.contentData.experience.include_explore_feedback) {
                this.props.onReviewObject(`option_${this.state.option.option_id}`);
            }
        }
    }


    getDisabledState() {
        let responseData = this.state.responseData;
        //if (responseData.displayState === objectConstants.OBJECT_DISPLAY_STATE_INITIAL) {
        if (responseData.currentAttempt === responseData.responses.length || this.state.isAnimating) {
            return `disabled`;
        } else {
            for (let i = 0; i < this.state.responseData.responses.length; i++) {
                let response = this.state.responseData.responses[i];
                if (response.selectedOption.option_id === this.state.option.option_id) {
                    return `disabled`;
                }
            }
            return null;
        }
    }

    handleOptionVisibility() {
        let responseData = this.state.responseData;
        let latestResponse = appHelper.getLastItemOfArray(responseData.responses);

        //if user responsed have been logged
        if (typeof latestResponse !== 'undefined' && responseData.displayState !== objectConstants.OBJECT_DISPLAY_STATE_REVIEW) {
            // if currentAttempt has been answered and the current option id does not equal the selected option if then hide it
            if ((responseData.currentAttempt === responseData.responses.length) && (latestResponse.selectedOption.option_id !== this.state.option.option_id)) {
                this.hideOption();
                // if currentAttempt has been answered and the current option id does equal the selected option if then show it but and the corners
            } else if ((responseData.currentAttempt === responseData.responses.length) && (latestResponse.selectedOption.option_id === this.state.option.option_id)) {
                this.roundCorners();
                // if currentAttempt has not been answered then render all options with no animation
            } else if ((responseData.currentAttempt > responseData.responses.length) && (latestResponse.selectedOption.option_id !== this.state.option.option_id)) {
                this.showOption(0.5, 0);
            }
            //if in review then reveal all options
        } else if (responseData.displayState === objectConstants.OBJECT_DISPLAY_STATE_REVIEW && appHelper.isDefined(latestResponse) && (latestResponse.selectedOption.option_id === this.state.option.option_id)) {
            this.showOption(0, 0);
        }
        else {
            if (!this.state.initialised) {
                this.showOption(0.5, (this.props.index * 0.5));
            }
        }
    }

    hideOption() {

        this.setAnimationStart();
        let optionRef = this.refs[this.state.option.option_id];


        if (appHelper.isDefined(optionRef) && optionRef.style.opacity !== "0") {
            TweenLite.to(optionRef, objectConstants.SPEECH_BUBBLE_DURATION, {
                opacity: 0,
                delay: 0,
                ease: Expo.easeOut
            }).eventCallback("onComplete", this.scaleOptionHeight);
        }
    }

    showOption(duration, delay) {
        this.setAnimationStart();
        let optionRef = this.refs[this.state.option.option_id];
        optionRef.classList.remove("rounded");
        if (appHelper.isDefined(optionRef)) {

            TweenLite.set(optionRef, {height: 0, opacity: 0});
            TweenLite.to(optionRef, objectConstants.SPEECH_BUBBLE_DURATION, {
                height: "auto",
                opacity: 1,
                delay: 0,
                ease: Expo.easeInOut
            }).eventCallback("onComplete", this.onOptionRevealed);

            if (!this.state.initialised) {
                this.setState({initialised: true});
            }
        }
    }

    onOptionRevealed() {
        let optionRef = this.refs[this.state.option.option_id];
        if (appHelper.isDefined(optionRef)) {
            optionRef.classList.remove("rounded");
        }
        this.setAnimationEnd();
        this.props.onOptionRevealed();
    }

    roundCorners() {

        let optionRef = this.refs[this.state.option.option_id];
        if (appHelper.isDefined(optionRef) && !optionRef.classList.contains("rounded")) {
            TweenLite.to(optionRef, objectConstants.SPEECH_BUBBLE_DURATION, {
                css: {className: '+=rounded'},
                delay: 0

            }).eventCallback("onComplete", this.setOptionAsSelected);
        }
    }


    setOptionAsSelected() {
        let optionRef = this.refs[this.state.option.option_id];
        if (appHelper.isDefined(optionRef)) {
            TweenLite.to(optionRef, objectConstants.SPEECH_BUBBLE_DURATION, {
                css: {className: this.props.showFeedback ? `+=selected ${this.state.option.result}` : `+=selected`},
                delay: 0
            });
        }
    }


    onOptionHidden() {
        let responseData = this.state.responseData;
        let latestResponse = appHelper.getLastItemOfArray(responseData.responses);

        //if selected option is first in the list
        if (latestResponse.index === 0) {
            this.removeOption();
        } else {
            this.scaleOptionHeight();
        }
    }

    scaleOptionHeight() {
        this.setAnimationStart();
        let optionRef = this.refs[this.state.option.option_id];
        if (appHelper.isDefined(optionRef)) {
            TweenLite.to(optionRef, objectConstants.SPEECH_BUBBLE_DURATION, {
                height: 0,
                ease: Expo.easeInOut
            }).eventCallback("onComplete", this.onAttemptComplete);
        }
    }

    onAttemptComplete() {

        this.props.onAttemptComplete();
    }

    removeOption() {
        //this.setState({render: false});
    }

    getIsChecked() {
        let responseData = this.state.responseData;
        let latestResponse = appHelper.getLastItemOfArray(responseData.responses);
        return appHelper.isDefined(latestResponse) && responseData.currentAttempt === responseData.responses.length && latestResponse.selectedOption.option_id === this.state.option.option_id;

    }

    getIsDisabled() {
        let responseData = this.state.responseData;
        //if (responseData.displayState === objectConstants.OBJECT_DISPLAY_STATE_INITIAL) {
        if (responseData.currentAttempt === responseData.responses.length || this.state.isAnimating) {
            return true;
        } else {
            for (let i = 0; i < this.state.responseData.responses.length; i++) {
                let response = this.state.responseData.responses[i];
                if (response.selectedOption.option_id === this.state.option.option_id) {
                    return true;
                }
            }
            return false;
        }
    }

    setFocus(){
        this.setState({focusedClass:"focused"});
    }
    setBlur(){
        this.setState({focusedClass:"not-focused"});
    }

    render() {

        return (

            <div className={`learner-action-option speak ${this.getOptionClass()} ${this.state.focusedClass}`}
                 ref={this.state.option.option_id}
                 id={`option_${this.state.option.option_id}`}
                 onClick={this.getClickFunction}
                 onKeyDown={this.props.optionCallbacks.setKeyboardAccessibility}
                 onFocus={this.setFocus}
                 onBlur={this.setBlur}
                 role="radio"
                 tabIndex={this.state.focusedOption.option_id === this.state.option.option_id ? 0 : -1}
                 aria-checked={this.getIsChecked()}
                 aria-disabled={this.getIsDisabled()}>
                <input id={`${this.props.asset_id}_${this.state.option.option_id}`} type="radio"
                       disabled={this.getDisabledState()}
                       name={this.props.asset_id}
                       value={this.state.option.option_id}
                       onChange={this.props.onOptionClick}

                />
                <label htmlFor={`${this.props.asset_id}_${this.state.option.option_id}`}>

                    <span dangerouslySetInnerHTML={{__html: `${this.state.locale.option}`}}/>
                    <span className="hidden-el">{this.getScreenReaderOptionClass()}</span>
                </label>

            </div>

        );

    }
}

ConversationSingleAnswerOption.propTypes = {
    option: PropTypes.object.isRequired,
    asset_id: PropTypes.number.isRequired,
    responseData: PropTypes.object.isRequired,
    index: PropTypes.number.isRequired,
    setOptionCanUpdate: PropTypes.func.isRequired,
    getOptionCanUpdate: PropTypes.func.isRequired,
    onOptionClick: PropTypes.func,
    onAttemptComplete: PropTypes.func,
    onReviewObject: PropTypes.func,
    onOptionRevealed: PropTypes.func,
    showFeedback: PropTypes.bool,
    focusedOption: PropTypes.object,
    optionCallbacks: PropTypes.object,
    contentData: PropTypes.object,
    trackingData: PropTypes.object,
    lang: PropTypes.string.isRequired,
    actions: PropTypes.object
};

ConversationSingleAnswerOption.contextTypes = {
    router: PropTypes.object
};

function mapStateToProps(state) {
    let lang = state.userData.lang;
    return {
        lang:lang,
        contentData: state.contentData,
        trackingData: state.trackingData,
    };
}

function mapDispatchToProps(dispatch) {
    return {
        actions: bindActionCreators(Object.assign({}, appDataActions, trackingDataActions, dialogPopupActions), dispatch)
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(ConversationSingleAnswerOption);



/** WEBPACK FOOTER **
 ** ./src/components/objects/multipleChoice/conversationSingleAnswer/ConversationSingleAnswerOption.js
 **/